import { Component, h } from '@stencil/core';

@Component({
  tag: 'household-icon',
  shadow: true,
})
export class HouseholdIcon {
  render() {
    return (
      <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="0.0012207" width="40" height="40" rx="8" fill="#6EC8F2" />
        <path
          d="M21.3392 8.51977C20.972 8.18515 20.4953 8 20.0012 8C19.5071 8 19.0305 8.18515 18.6632 8.51977L8.00122 18.2334V28.7608C8.00122 29.6199 8.33836 30.4438 8.93848 31.0513C9.5386 31.6587 10.3525 32 11.2012 32H28.8012C29.6499 32 30.4638 31.6587 31.064 31.0513C31.6641 30.4438 32.0012 29.6199 32.0012 28.7608V18.2334L21.3392 8.51977ZM23.0012 29.9725H17.0012V24.8849C17.0012 24.0795 17.3173 23.3071 17.8799 22.7376C18.4425 22.1681 19.2056 21.8481 20.0012 21.8481C20.7969 21.8481 21.5599 22.1681 22.1225 22.7376C22.6852 23.3071 23.0012 24.0795 23.0012 24.8849V29.9725ZM30.0012 28.7578C30.0012 29.0799 29.8748 29.3889 29.6497 29.6167C29.4247 29.8445 29.1195 29.9725 28.8012 29.9725H25.0012V24.8849C25.0012 23.5425 24.4744 22.2552 23.5368 21.306C22.5991 20.3568 21.3273 19.8236 20.0012 19.8236C18.6751 19.8236 17.4034 20.3568 16.4657 21.306C15.528 22.2552 15.0012 23.5425 15.0012 24.8849V29.9725H11.2012C10.883 29.9725 10.5777 29.8445 10.3527 29.6167C10.1276 29.3889 10.0012 29.0799 10.0012 28.7578V19.1343L20.0012 10.024L30.0012 19.1343V28.7578Z"
          fill="#333333"
        />
      </svg>
    );
  }
}
